<script>
export default {
  name: 'SuccessIcon',
  props: {
    className: String
  }
}
</script>

<template>
  <span
    :class="[
      'material-symbols-outlined',
      'success-icon',
      className
    ]"
    >
    check
  </span>
</template>

<style scoped lang="scss">
.success-icon {
  font-size: 22px;
  color: $iconColorSuccess;
  cursor: default;
}
</style>
